import React from 'react';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NotesWrapper from '../../pages/Patients/components/NotesWrapper';
import PatientNote from '../PatientNote';
import CaseNotes from '../CaseNotes';
import OnHoldNotes from '../OnHoldNotes';
import { isDoctor } from '../../helpers';

const NotesSection = ({
  patient,
  isManagement,
  hasCaseNotes,
  customBracketSetRequest,
  hideTechNotes
}) => {
  const doctor = patient.user;
  const preferenceNotes = (doctor && doctor.preference_notes) || '';
  const showPreferenceNotes = isManagement && doctor && isDoctor(doctor);

  return (
    <>
      <Grid item xs={12}>
        <NotesWrapper
          title="Case Notes"
          description="Communication between Doctors and the DIBS Team."
          actionCellProps
          type="case_notes"
          hasNotes={hasCaseNotes}
        >
          <CaseNotes patientId={patient.id} />
        </NotesWrapper>
      </Grid>

      {isManagement && (
        <>
          <Grid item xs={12}>
            <NotesWrapper
              title="Internal Notes (Doctor)"
              hasNotes={!!patient.doctor_notes}
              description="Doctor use only"
            >
              <PatientNote
                patientId={patient.id}
                note={patient.doctor_notes || ''}
                noteIdentifier="doctor_notes"
                label="Internal Notes (Doctor)"
                rows={6}
                disabled
              />
            </NotesWrapper>
          </Grid>
          {!hideTechNotes && (
            <Grid item xs={12}>
              <NotesWrapper title="Atoms" hasNotes={!!patient.physical_tech_notes}>
                <PatientNote
                  patientId={patient.id}
                  note={patient.physical_tech_notes || ''}
                  noteIdentifier="physical_tech_notes"
                  label="Atoms"
                  rows={6}
                />
              </NotesWrapper>
            </Grid>
          )}
          {!hideTechNotes && (
            <Grid item xs={12}>
              <NotesWrapper title="Bits" hasNotes={!!patient.internal_notes}>
                <PatientNote
                  patientId={patient.id}
                  note={patient.internal_notes || ''}
                  noteIdentifier="internal_notes"
                  label="Bits"
                  rows={6}
                />
              </NotesWrapper>
            </Grid>
          )}
        </>
      )}
      {!isManagement && (
        <>
          <Grid item xs={12}>
            <NotesWrapper
              title="Internal Notes"
              hasNotes={!!patient.doctor_internal_notes}
              description="Doctor & staff communication only"
            >
              <PatientNote
                patientId={patient.id}
                note={patient.doctor_internal_notes || ''}
                noteIdentifier="doctor_internal_notes"
                label="Internal Notes"
                rows={6}
              />
            </NotesWrapper>
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <NotesWrapper
          title="On Hold Notes"
          hasNotes={!!patient.on_hold_notes && !!patient.on_hold_notes.length}
          description={isManagement ? '' : 'Record of when/if this case was placed on hold'}
        >
          <OnHoldNotes
            patientId={patient.id}
            notes={patient.on_hold_notes || []}
            label="On Hold Notes"
            rows={6}
            disabled={!patient.is_on_hold}
          />
        </NotesWrapper>
      </Grid>
      {showPreferenceNotes && (
        <Grid item xs={12}>
          <NotesWrapper
            title="Preference Notes"
            description="Doctor's preference notes."
            type="preference_notes"
            hasNotes={!!preferenceNotes}
          >
            <PatientNote
              patientId={patient.id}
              note={preferenceNotes}
              noteIdentifier="preference_notes"
              rows={6}
              disabled
            />
          </NotesWrapper>
        </Grid>
      )}
    </>
  );
};

NotesSection.propTypes = {
  patient: PropTypes.shape({
    id: PropTypes.number,
    doctor_notes: PropTypes.string,
    doctor_internal_notes: PropTypes.string,
    physical_tech_notes: PropTypes.string,
    internal_notes: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    on_hold_notes: PropTypes.arrayOf(PropTypes.object),
    is_on_hold: PropTypes.bool,
    user: PropTypes.shape({
      preference_notes: PropTypes.string,
      // eslint-disable-next-line react/forbid-prop-types
      roles: PropTypes.array
    })
  }).isRequired,
  isManagement: PropTypes.bool.isRequired,
  hasCaseNotes: PropTypes.bool.isRequired,
  customBracketSetRequest: PropTypes.shape({
    name: PropTypes.string.isRequired,
    notes: PropTypes.string
  }),
  hideTechNotes: PropTypes.bool
};

NotesSection.defaultProps = {
  customBracketSetRequest: null,
  hideTechNotes: false
};

export default connect((state, ownProps) => {
  const localState = state.caseNotes;
  const { patient } = ownProps;
  const patientState = localState.patientId === patient?.id ? localState : {};
  return {
    isManagement: state.auth.isManagement,
    hasCaseNotes: patientState?.messages?.length > 0
  };
})(NotesSection);
